import { useState } from 'react';
import GeoIpFinder from './GeoIpFinder'
import TabItem from './TabItem';
import Card from '../../common/card/Card';
import {
    set_data_reset_itemone,
} from '../../../redux/actions/appActions'
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from "next/router";
import HeadingServices from '../../services/HeadingServices';

export default function Geoip({ datas }) {

    const dispatch = useDispatch()
    const router = useRouter();
    let language = router.locale === "tr" ? "Turkish" : "English";
    const [isLoading, setIsLoading] = useState(false);
    const [infoMessage, setInfoMessage] = useState('')
    const stateData = useSelector(state => state.app);
    const { data, headers, userAgent, ip } = stateData;


    const onCloseHandlerItem = (id) => {
        dispatch(set_data_reset_itemone(id))
    }



    const tabComp = Object.values(data).map((item, i) => {
        return <TabItem
            key={Math.random().toString()}
            datas={datas}
            onDeleteItem={onCloseHandlerItem}
            isLoadMax={isLoading}
            item={item}
            language={language}
            tabName="mm"
            ip={Object.keys(data)[i]}
        />
    }
    )




    return (
        <>
            <HeadingServices
                title={datas.upperTitle}
                lowerTitle={datas.title} />
            <div className="container mt-2 py-3 mb-5">
                {/* Search bar  */}
                <GeoIpFinder
                    setIsLoading={setIsLoading}
                    infoMessage={infoMessage}
                    setInfoMessage={setInfoMessage}
                    placeHolder={datas.placeHolder}
                    buttonSearch={datas.buttonSearch}
                    buttonClear={datas.buttonClear}
                    placeHolderDetail={datas.placeHolderDetail}
                    info={datas.info}
                />
                {/* Result cards */}
                {tabComp}
                {headers &&
                    <div className="card shadow row no-gutters mt-5">
                        <div className="col-12">
                            <Card
                                title={datas.systemTitle}
                                ips={ip}
                                items={[
                                    { name: datas.opTitle, value: `${userAgent["platform"]}, ${userAgent["os"]}` },
                                    { name: datas.browser, value: `${userAgent["browser"]}, ${userAgent["version"]}` },
                                    { name: datas.userA, value: headers.userAgent },
                                    { name: datas.accept, value: headers.accept },
                                    { name: datas.encoding, value: headers.encoding },
                                    { name: datas.lang, value: headers.language },
                                    { name: datas.conn, value: headers.connection }
                                ]}
                            />
                        </div>
                    </div>
                }
            </div>
        </>
    )
}
